import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ds-progress-bar',
  templateUrl: './ds-progress-bar.component.html',
  styleUrls: ['./ds-progress-bar.component.scss']
})
export class DsProgressBarComponent {
  @Input() value: number = 0;

  get clampedValue(): number {
    if (!this.value || this.value < 0) {
      return 0;
    }
    if (this.value > 100) {
      return 100;
    }
    return this.value;
  }
}
